import { render, staticRenderFns } from "./FoodSideDishes.vue?vue&type=template&id=38561f2e&scoped=true"
import script from "./FoodSideDishes.vue?vue&type=script&lang=js"
export * from "./FoodSideDishes.vue?vue&type=script&lang=js"
import style0 from "./FoodSideDishes.vue?vue&type=style&index=0&id=38561f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38561f2e",
  null
  
)

export default component.exports